module.exports = __webpack_public_path__ + "static/media/origin-snap2.b5cd41ce.png";